
export let countryCodes = [
    //     { id:'3', label: 'Andorra', value:'AD' },
    //     { id:'4', label: 'United-Arab-Emirates', value:'AE' },
    //     { id:'5', label: 'Afghanistan', value:'AF' },
    //     { id:'6', label: 'Antigua-and-Barbuda', value:'AG' },
    //     { id:'7', label: 'Anguilla', value:'AI' },
    //     { id:'8', label: 'Albania', value:'AL' },
    //     { id:'9', label: 'Armenia', value:'AM' },
    //     { id:'10', label: 'Netherlands-Antilles', value:'AN' },
    //     { id:'11', label: 'Angola', value:'AO' },
    //     { id:'13', label: 'Antarctica', value:'AQ' },
    //     { id:'14', label: 'Argentina', value:'14' },
    //     { id:'15', label: 'American-Samoa', value:'15' },
    //     { id:'16', label: 'Austria', value:'16' },
    //     { id:'17', label: 'Australia', value:'17' },
    //     { id:'18', label: 'Aruba', value:'18' },
    //     { id:'19', label: 'Aland', value:'19' },
    //     { id:'20', label: 'Azerbaijan', value:'20' },
    //     { id:'21', label: 'Bosnia-and-Herzegovina', value:'21' },
    //     { id:'22', label: 'Barbados', value:'22' },
    //     { id:'23', label: 'Bangladesh', value:'23' },
    //     { id:'24', label: 'Belgium', value:'24' },
    //     { id:'25', label: 'Burkina-Faso', value:'25' },
    //     { id:'26', label: 'Bulgaria', value:'26' },
    //     { id:'27', label: 'Bahrain', value:'27' },
    //     { id:'28', label: 'Burundi', value:'28' },
    //     { id:'29', label: 'Benin', value:'29' },
    //     { id:'30', label: 'Bermuda', value:'30' },
    //     { id:'31', label: 'Brunei', value:'31' },
    //     { id:'32', label: 'Bolivia', value:'32' },
    //     { id:'33', label: 'Brazil', value:'33' },
    //     { id:'34', label: 'Bahamas', value:'34' },
    //     { id:'35', label: 'Bhutan', value:'35' },
    //     { id:'37', label: 'Botswana', value:'37' },
    //     { id:'38', label: 'Belarus', value:'38' },
    //     { id:'39', label: 'Belize', value:'39' },
    //     { id:'40', label: 'Canada', value:'40' },
    //     { id:'41', label: 'Cocos-Keeling-Islands', value:'41' },
    //     { id:'42', label: 'Democratic-Republic-of-the-Congo', value:'42' },
    //     { id:'43', label: 'Central-African-Republic', value:'43' },
    //     { id:'44', label: 'Republic-of-the-Congo', value:'44' },
    //     { id:'45', label: 'Switzerland', value:'45' },
    //     { id:'46', label: 'Cote-dIvoire', value:'46' },
    //     { id:'47', label: 'Cook-Islands', value:'47' },
    //     { id:'48', label:'Chile', value:'48' },
    //     { id:'49', label:'Cameroon', value:'49' },
    //     { id:'50', label:'China', value:'50' },
    //     { id:'51', label:'Colombia', value:'51' },
    //     { id:'52', label:'Costa-Rica', value:'52' },
    //     { id:'53', label:'Cuba', value:'53' },
    //     { id:'54', label:'Cape-Verde', value:'54' },
    //     { id:'55', label:'Christmas-Island', value:'55' },
    //     { id:'56', label:'Cyprus', value:'56' },
    //     { id:'57', label:'Czech-Republic', value:'57' },
    //     { id:'58', label:'Germany', value:'58' },
    //     { id:'59', label:'Djibouti', value:'59' },
    //     { id:'60', label:'Denmark', value:'60' },
    //     { id:'61', label:'Dominica', value:'61' },
    //     { id:'62', label:'Dominican-Republic', value:'62' },
    //     { id:'63', label:'Algeria', value:'63' },
    //     { id:'64', label:'Ecuador', value:'64' },
    //     { id:'65', label:'Estonia', value:'65' },
    //     { id:'66', label:'Egypt', value:'66' },
    //     { id:'67', label:'Western-Sahara', value:'67' },
    //     { id:'68', label:'Eritrea', value:'68' },
    //     { id:'69', label:'Spain', value:'69' },
    //     { id:'70', label:'Ethiopia', value:'70' },
    //     { id:'71', label:'European-Union', value:'71' },
    //     { id:'72', label:'Finland', value:'72' },
    //     { id:'73', label:'Fiji', value:'73' },
    //     { id:'74', label:'Falkland-Islands', value:'74' },
    //     { id:'75', label:'Micronesia', value:'75' },
    //     { id:'76', label:'Faroes', value:'76' },
    //     { id:'77', label:'France', value:'77' },
    //     { id:'78', label:'Gabon', value:'78' },
    //     { id:'79', label:'United-Kingdom', value:'79' },
    //     { id:'80', label:'Grenada', value:'80' },
    //     { id:'81', label:'Georgia', value:'81' },
    //  // { id:'82',label:'French Guiana',value:'82' },
    //     { id:'83', label:'Guernsey', value:'83' },
    //     { id:'84', label:'Ghana', value:'84' },
    //     { id:'85', label:'Gibraltar', value:'85' },
    //     { id:'86', label:'Greenland', value:'86' },
    //     { id:'87', label:'Gambia', value:'87' },
    //     { id:'88', label:'Guinea', value:'88' },
    // //  { id:'89',label:'Guadeloupe',value:'89' },
    //     { id:'90', label:'Equatorial-Guinea', value:'90' },
    //     { id:'91', label:'Greece', value:'91' },
    //     { id:'92', label:'South-Georgia-and-the-South-Sandwich-Islands', value:'92' },
    //     { id:'93', label:'Guatemala', value:'93' },
    //     { id:'94', label:'Guam', value:'94' },
    //     { id:'95', label:'Guinea-Bissau', value:'95' },
    //     { id:'96', label:'Guyana', value:'96' },
    //     { id:'97', label:'Hong-Kong', value:'97' },
    // //  { id:'98', label:'Heard Island and McDonald Island', value:'98' },
    //     { id:'99', label:'Honduras', value:'99' },
    //     { id:'100', label:'Croatia', value:'100' },
    //     { id:'101', label:'Haiti', value:'101' },
    //     { id:'102', label:'Hungary', value:'102' },
    //     { id:'103', label:'Indonesia', value:'103' },
    //     { id:'104', label:'Ireland', value:'104' },
    //     { id:'105', label:'Israel', value:'105' },
    //     { id:'106', label:'Isle-of-Man', value:'106' },
    //     { id:'107', label:'India', value:'107' },
    //  // { id:'108',label:'British Indian Ocean Territory',value:'108' },
    //     { id:'109', label:'Iraq', value:'109' },
    //     { id:'110', label:'Iran', value:'110' },
    //     { id:'111', label:'Iceland', value:'111' },
    //     { id:'112', label:'Italy', value:'112' },
    //     { id:'113', label:'Jersey', value:'113' },
    //     { id:'114', label:'Jamaica', value:'114' },
    //     { id:'115', label:'Jordan', value:'115' },
    //     { id:'116', label:'Japan', value:'116' },
    //     { id:'117', label:'Kenya', value:'117' },
    //     { id:'118', label:'Kyrgyzstan', value:'118' },
    //     { id:'119', label:'Cambodia', value:'119' },
    //     { id:'120', label:'Kiribati', value:'120' },
    //     { id:'121', label:'Comoros', value:'121' },
    //     { id:'122', label:'Saint-Kitts-and-Nevis', value:'122' },
    //     { id:'123', label:'North-Korea', value:'123' },
    //     { id:'124', label:'South-Korea', value:'124' },
    //     { id:'125', label:'Kuwait', value:'125' },
    //     { id:'126', label:'Cayman-Islands', value:'126' },
    //     { id:'127', label:'Kazakhstan', value:'127' },
    //     { id:'128', label:'Laos', value:'128' },
    //     { id:'129', label:'Lebanon', value:'129' },
    //     { id:'130', label:'Saint-Lucia', value:'130' },
    //     { id:'131', label:'Liechtenstein', value:'131' },
    //     { id:'132', label:'Sri-Lanka', value:'132' },
    //     { id:'133', label:'Liberia', value:'133' },
    //     { id:'134', label:'Lesotho', value:'134' },
    //     { id:'135', label:'Lithuania', value:'135' },
    //     { id:'136', label:'Luxembourg', value:'136' },
    //     { id:'137', label:'Latvia', value:'137' },
    //     { id:'138', label:'Libya', value:'138' },
    //     { id:'139', label:'Morocco', value:'139' },
    //     { id:'140', label:'Monaco', value:'140' },
    //     { id:'141', label:'Moldova', value:'141' },
    //     { id:'142', label:'Montenegro', value:'142' },
    //     { id:'143', label:'Madagascar', value:'143' },
    //     { id:'144', label:'Marshall-Islands', value:'144' },
    //     { id:'145', label:'Macedonia', value:'145' },
    //     { id:'146', label:'Mali', value:'146' },
    //     { id:'147', label:'Myanmar', value:'147' },
    //     { id:'148', label:'Mongolia', value:'148' },
    //     { id:'149', label:'Macau', value:'149' },
    //     { id:'150', label:'Northern-Mariana-Islands', value:'150' },
    //     { id:'151', label:'Martinique', value:'151' },
    //     { id:'152', label:'Mauritania', value:'152' },
    //     { id:'153', label:'Montserrat', value:'153' },
    //     { id:'154', label:'Malta', value:'154' }, // check
    //     { id:'155', label:'Mauritius', value:'155' },
    //     { id:'156', label:'Maldives', value:'156' },
    //     { id:'157', label:'Malawi', value:'157' },
    //     { id:'158', label:'Mexico', value:'158' },
    //     { id:'159', label:'Malaysia', value:'159' },
    //     { id:'160', label:'Mozambique', value:'160' },
    //     { id:'161', label:'Namibia', value:'161' },
    //     { id:'162', label:'New-Caledonia', value:'162' },
    //     { id:'163', label:'Niger', value:'163' },
    //     { id:'164', label:'Norfolk-Island', value:'164' },
    //     { id:'165', label:'Nigeria', value:'165' },
    //     { id:'166', label:'Nicaragua', value:'166' },
    //     { id:'167', label:'Netherlands', value:'167' },
    //     { id:'168', label:'Norway', value:'168' },
    //     { id:'169', label:'Nepal', value:'169' },
    //     { id:'170', label:'Nauru', value:'170' },
    //     { id:'171', label:'Niue', value:'171' },
    //     { id:'172', label:'New-Zealand', value:'172' },
    // //  { id:'173',label:'Other Country.png',value:'173' },
    //     { id:'174', label:'Oman', value:'174' },
    //     { id:'175', label:'Panama', value:'175' },
    //     { id:'176', label:'Peru', value:'176' },
    //     { id:'177', label:'French-Polynesia', value:'177' },
    //     { id:'178', label:'Papua-New-Guinea', value:'178' },
    //     { id:'179', label:'Philippines', value:'179' },
    //     { id:'180', label:'Pakistan', value:'180' },
    //     { id:'181', label:'Poland', value:'181' },
    //  // { id:'182',label:'Saint Pierre and Miquelon',value:'182' },
    //  // { id:'183',label:'unknown',value:'183' },
    //     { id:'184', label:'Puerto-Rico', value:'184' },
    //     { id:'185', label:'Palestine', value:'185' },
    //     { id:'186', label:'Portugal', value:'186' },
    //     { id:'187', label:'Palau', value:'187' },
    //     { id:'188', label:'Paraguay', value:'188' },
    //     { id:'189', label:'Qatar', value:'189' },
    //     { id:'190', label:'Reunion', value:'190' },
    //     { id:'191', label:'Romania', value:'191' },
    //     { id:'192', label:'Serbia', value:'192' },
    //     { id:'193', label:'Russia', value:'193' },
    //     { id:'194', label:'Rwanda', value:'194' },
    //     { id:'195', label:'Saudi-Arabia', value:'195' },
    //     { id:'196', label:'Solomon-Islands', value:'196' },
    //     { id:'197', label:'Seychelles', value:'197' },
    //     { id:'198', label:'Sudan', value:'198' },
    //     { id:'199', label:'Sweden', value:'199' },
    //     { id:'200', label:'Singapore', value:'200' },
    //     { id:'201', label:'Saint-Helena', value:'201' },
    //     { id:'202', label:'Slovenia', value:'202' },
    //     { id:'203', label:'Svalbard and Jan Mayen', value:'203' },
    //     { id:'204', label:'Slovakia', value:'204' },
    //     { id:'205', label:'Sierra-Leone', value:'205' },
    //     { id:'206', label:'San-Marino', value:'206' },
    //     { id:'207', label:'Senegal', value:'207' },
    //     { id:'208', label:'Somalia', value:'208' },
    //     { id:'209', label:'Suriname', value:'209' },
    //     { id:'210', label:'Sao-Tome-and-Principe', value:'210' },
    //     { id:'211', label:'El-Salvador', value:'211' },
    //     { id:'212', label:'Syria', value:'212' },
    //     { id:'213', label:'Swaziland', value:'213' },
    //     { id:'214', label:'Turks-and-Caicos-Islands.', value:'214' },
    //     { id:'215', label:'Chad', value:'215' },
    //     { id:'216', label:'French-Southern-Territories', value:'216' },
    //     { id:'217', label:'Togo', value:'217' },
    //     { id:'218', label:'Thailand', value:'218' },
    //     { id:'219', label:'Tajikistan', value:'219' },
    //     { id:'220', label:'Tokelau', value:'220' },
    // //  { id:'221',label:'unknown',value:'221' },
    //     { id:'222', label:'Turkmenistan', value:'222' },
    //     { id:'223', label:'Tunisia', value:'223' },
    //     { id:'224', label:'Tonga', value:'224' },
    //     { id:'225', label:'Turkey', value:'225' },
    //     { id:'226', label:'Trinidad-and-Tobago', value:'226' },
    //     { id:'227', label:'Tuvalu', value:'227' },
    //     { id:'228', label:'Taiwan', value:'228' },
    //     { id:'229', label:'Tanzania', value:'229' },
    //     { id:'230', label:'Ukraine', value:'230' },
    //     { id:'231', label:'Uganda', value:'231' },
    // //  { id:'232',label:'United States Minor Outlying Is',value:'232' },
    //     { id:'233', label:'United-States', value:'233' },
    //     { id:'234', label:'Uruguay', value:'234' },
    //     { id:'235', label:'Uzbekistan', value:'235' },
    //     { id:'236', label:'Vatican-City', value:'236' },
    //     { id:'237', label:'Saint-Vincent-and-the-Grenadines', value:'237' },
    //     { id:'238', label:'Venezuela', value:'238' },
    //     { id:'239', label:'British-Virgin-Islands', value:'239' },
    //     { id:'240', label:'US-Virgin-Islands', value:'240' },
    //     { id:'241', label:'Vietnam', value:'241' },
    //     { id:'242', label:'Vanuatu', value:'242' },
    //     { id:'243', label:'Wallis-And-Futuna', value:'243' },
    //     { id:'244', label:'Samoa', value:'244' },
    //     { id:'245', label:'Yemen', value:'245' },
    //     { id:'246', label:'Mayotte', value:'246' },
    //     { id:'247', label:'South-Africa', value:'247' },
    //     { id:'248', label:'Zambia', value:'248' },
    //     { id:'249', label:'Zimbabwe', value:'249' },
    //     { id:'250', label:'Saint-Martin', value:'250' },
    //     { id:'251', label:'Pitcairn-Islands', value:'251' },
    //     { id:'252', label:'Timor-Leste', value:'252' },
    //     { id:'253', label:'Curacao', value:'253' },
    { id:'3', label :'Andorra', value :'AD' },
    { id:'4', label :'United-Arab-Emirates', value :'AE' },
    { id:'5', label :'Afghanistan', value :'AF' },
    { id:'6', label :'Antigua-and-Barbuda', value :'AG' },
    { id:'7', label :'Anguilla', value :'AI' },
    { id:'8', label :'Albania', value :'AL' },
    { id:'9', label :'Armenia', value :'AM' },
    { id:'10', label :'Netherlands-Antilles', value :'AN' },
    { id:'11', label :'Angola', value :'AO' },
    { id:'13', label :'Antarctica', value :'AQ' },
    { id:'14', label :'Argentina', value :'AR' },
    { id:'15', label :'American-Samoa', value :'AS' },
    { id:'16', label :'Austria', value :'AT' },
    { id:'17', label :'Australia', value :'AU' },
    { id:'18', label :'Aruba', value :'AW' },
    { id:'19', label :'Aland', value :'19' },
    { id:'20', label :'Azerbaijan', value :'AZ' },
    { id:'21', label :'Bosnia-and-Herzegovina', value :'BA' },
    { id:'22', label :'Barbados', value :'BB' },
    { id:'23', label :'Bangladesh', value :'BD' },
    { id:'24', label :'Belgium', value :'BE' },
    { id:'25', label :'Burkina-Faso', value :'BF' },
    { id:'26', label :'Bulgaria', value :'BG' },
    { id:'27', label :'Bahrain', value :'BH' },
    { id:'28', label :'Burundi', value :'BI' },
    { id:'29', label :'Benin', value :'BJ' },
    { id:'30', label :'Bermuda', value :'BM' },
    { id:'31', label :'Brunei', value :'BN' },
    { id:'32', label :'Bolivia', value :'BO' },
    { id:'33', label :'Brazil', value :'BR' },
    { id:'34', label :'Bahamas', value :'BS' },
    { id:'35', label :'Bhutan', value :'BT' },
    { id:'37', label :'Botswana', value :'BW' },
    { id:'38', label :'Belarus', value :'BY' },
    { id:'39', label :'Belize', value :'BZ' },
    { id:'40', label :'Canada', value :'CA' },
    { id:'41', label :'Cocos-Keeling-Islands', value :'CC' },
    { id:'42', label :'Democratic-Republic-of-the-Congo', value :'CD' },
    { id:'43', label :'Central-African-Republic', value :'CF' },
    { id:'44', label :'Republic-of-the-Congo', value :'CG' },
    { id:'45', label :'Switzerland', value :'CH' },
    { id:'46', label :'Cote-dIvoire', value :'CI' },
    { id:'47', label :'Cook-Islands', value :'CK' },
    { id:'48', label :'Chile', value :'CL' },
    { id:'49', label :'Cameroon', value :'CM' },
    { id:'50', label :'China', value :'CN' },
    { id:'51', label :'Colombia', value :'CO' },
    { id:'52', label :'Costa-Rica', value :'CR' },
    { id:'53', label :'Cuba', value :'53' },
    { id:'54', label :'Cape-Verde', value :'CV' },
    { id:'55', label :'Christmas-Island', value :'CX' },
    { id:'56', label :'Cyprus', value :'CY' },
    { id:'57', label :'Czech-Republic', value :'CZ' },
    { id:'58', label :'Germany', value :'DE' },
    { id:'59', label :'Djibouti', value :'DJ' },
    { id:'60', label :'Denmark', value :'DK' },
    { id:'61', label :'Dominica', value :'DM' },
    { id:'62', label :'Dominican-Republic', value :'DO' },
    { id:'63', label :'Algeria', value :'DZ' },
    { id:'64', label :'Ecuador', value :'EC' },
    { id:'65', label :'Estonia', value :'EE' },
    { id:'66', label :'Egypt', value :'EG' },
    { id:'67', label :'Western-Sahara', value :'EH' },
    { id:'68', label :'Eritrea', value :'ER' },
    { id:'69', label :'Spain', value :'ES' },
    { id:'70', label :'Ethiopia', value :'ET' },
    { id:'71', label :'European-Union', value :'71' },
    { id:'72', label :'Finland', value :'FI' },
    { id:'73', label :'Fiji', value :'FJ' },
    { id:'74', label :'Falkland-Islands', value :'FK' },
    { id:'75', label :'Micronesia', value :'FM' },
    { id:'76', label :'Faroes', value :'FO' },
    { id:'77', label :'France', value :'FR' },
    { id:'78', label :'Gabon', value :'GA' },
    { id:'79', label :'United-Kingdom', value :'GB' },
    { id:'80', label :'Grenada', value :'GD' },
    { id:'81', label :'Georgia', value :'GE' },
    { id:'82', label:'French Guiana', value:'GF' },
    { id:'83', label :'Guernsey', value :'83' },
    { id:'84', label :'Ghana', value :'GH' },
    { id:'85', label :'Gibraltar', value :'GI' },
    { id:'86', label :'Greenland', value :'GL' },
    { id:'87', label :'Gambia', value :'GM' },
    { id:'88', label :'Guinea', value :'GN' },
    { id:'89', label:'Guadeloupe', value:'GP' },
    { id:'90', label :'Equatorial-Guinea', value :'GQ' },
    { id:'91', label :'Greece', value :'GR' },
    { id:'92', label :'South-Georgia-and-the-South-Sandwich-Islands', value :'GS' },
    { id:'93', label :'Guatemala', value :'GT' },
    { id:'94', label :'Guam', value :'GU' },
    { id:'95', label :'Guinea-Bissau', value :'GW' },
    { id:'96', label :'Guyana', value :'GY' },
    { id:'97', label :'Hong-Kong', value :'HK' },
    { id:'98', label:'Heard Island and McDonald Island', value:'HM' },
    { id:'99', label :'Honduras', value :'HN' },
    { id:'100', label :'Croatia', value :'HR' },
    { id:'101', label :'Haiti', value :'HT' },
    { id:'102', label :'Hungary', value :'HU' },
    { id:'103', label :'Indonesia', value :'ID' },
    { id:'104', label :'Ireland', value :'IE' },
    { id:'105', label :'Israel', value :'IL' },
    { id:'106', label :'Isle-of-Man', value :'106' },
    { id:'107', label :'India', value :'IN' },
    { id:'108', label:'British Indian Ocean Territory', value:'IO' },
    { id:'109', label :'Iraq', value :'109' },
    { id:'110', label :'Iran', value :'110' },
    { id:'111', label :'Iceland', value :'IS' },
    { id:'112', label :'Italy', value :'IT' },
    { id:'113', label :'Jersey', value :'113' },
    { id:'114', label :'Jamaica', value :'JM' },
    { id:'115', label :'Jordan', value :'JO' },
    { id:'116', label :'Japan', value :'JP' },
    { id:'117', label :'Kenya', value :'KE' },
    { id:'118', label :'Kyrgyzstan', value :'KG' },
    { id:'119', label :'Cambodia', value :'KH' },
    { id:'120', label :'Kiribati', value :'KI' },
    { id:'121', label :'Comoros', value :'KM' },
    { id:'122', label :'Saint-Kitts-and-Nevis', value :'KN' },
    { id:'123', label :'North-Korea', value :'KR' },
    { id:'124', label :'South-Korea', value :'KR' },
    { id:'125', label :'Kuwait.png', value :'KW' },
    { id:'126', label :'Cayman-Islands', value :'KY' },
    { id:'127', label :'Kazakhstan', value :'KZ' },
    { id:'128', label :'Laos', value :'LA' },
    { id:'129', label :'Lebanon', value :'LB' },
    { id:'130', label :'Saint-Lucia', value :'LC' },
    { id:'131', label :'Liechtenstein', value :'LI' },
    { id:'132', label :'Sri-Lanka', value :'LK' },
    { id:'133', label :'Liberia', value :'LR' },
    { id:'134', label :'Lesotho', value :'LS' },
    { id:'135', label :'Lithuania', value :'LT' },
    { id:'136', label :'Luxembourg', value :'LU' },
    { id:'137', label :'Latvia', value :'LV' },
    { id:'138', label :'Libya', value :'LY' },
    { id:'139', label :'Morocco', value :'MA' },
    { id:'140', label :'Monaco', value :'MC' },
    { id:'141', label :'Moldova', value :'MD' },
    { id:'142', label :'Montenegro', value :'ME' },
    { id:'143', label :'Madagascar', value :'MG' },
    { id:'144', label :'Marshall-Islands', value :'MH' },
    { id:'145', label :'Macedonia', value :'MK' },
    { id:'146', label :'Mali', value :'ML' },
    { id:'147', label :'Myanmar', value :'MM' },
    { id:'148', label :'Mongolia', value :'MN' },
    { id:'149', label :'Macau', value :'149' },
    { id:'150', label :'Northern-Mariana-Islands', value :'MP' },
    { id:'151', label :'Martinique', value :'MQ' },
    { id:'152', label :'Mauritania', value :'MR' },
    { id:'153', label :'Montserrat', value :'MS' },
    { id:'154', label :'Malta', value :'MT' },
    { id:'155', label :'Mauritius', value :'MU' },
    { id:'156', label :'Maldives', value :'MV' },
    { id:'157', label :'Malawi', value :'MW' },
    { id:'158', label :'Mexico', value :'MX' },
    { id:'159', label :'Malaysia', value :'MY' },
    { id:'160', label :'Mozambique', value :'MZ' },
    { id:'161', label :'Namibia', value :'NA' },
    { id:'162', label :'New-Caledonia', value :'NC' },
    { id:'163', label :'Niger', value :'NE' },
    { id:'164', label :'Norfolk-Island', value :'NF' },
    { id:'165', label :'Nigeria', value :'NG' },
    { id:'166', label :'Nicaragua', value :'NI' },
    { id:'167', label :'Netherlands', value :'NL' },
    { id:'168', label :'Norway', value :'NO' },
    { id:'169', label :'Nepal', value :'NP' },
    { id:'170', label :'Nauru', value :'NR' },
    { id:'171', label :'Niue', value :'NU' },
    { id:'172', label :'New-Zealand', value :'NZ' },
    { id:'174', label :'Oman', value :'OM' },
    { id:'175', label :'Panama', value :'PA' },
    { id:'176', label :'Peru', value :'PE' },
    { id:'177', label :'French-Polynesia', value :'PF' },
    { id:'178', label :'Papua-New-Guinea', value :'PG' },
    { id:'179', label :'Philippines', value :'PH' },
    { id:'180', label :'Pakistan', value :'PK' },
    { id:'181', label :'Poland', value :'PL' },
    { id:'182', label:'Saint Pierre and Miquelon', value:'PM' },
    { id:'184', label :'Puerto-Rico', value :'PR' },
    { id:'185', label :'Palestine', value :'185' },
    { id:'186', label :'Portugal', value :'PT' },
    { id:'187', label :'Palau', value :'PW' },
    { id:'188', label :'Paraguay', value :'PY' },
    { id:'189', label :'Qatar', value :'QA' },
    { id:'190', label :'Reunion', value :'RE' },
    { id:'191', label :'Romania', value :'RO' },
    { id:'192', label :'Serbia', value :'RS' },
    { id:'193', label :'Russia', value :'RU' },
    { id:'194', label :'Rwanda', value :'RW' },
    { id:'195', label :'Saudi-Arabia', value :'SA' },
    { id:'196', label :'Solomon-Islands', value :'SB' },
    { id:'197', label :'Seychelles', value :'SC' },
    { id:'198', label :'Sudan', value :'198' },
    { id:'199', label :'Sweden', value :'SE' },
    { id:'200', label :'Singapore', value :'SG' },
    { id:'201', label :'Saint-Helena', value :'SH' },
    { id:'202', label :'Slovenia', value :'SI' },
    { id:'203', label :'Svalbard and Jan Mayen', value :'SJ' },
    { id:'204', label :'Slovakia', value :'SK' },
    { id:'205', label :'Sierra-Leone', value :'SL' },
    { id:'206', label :'San-Marino', value :'SM' },
    { id:'207', label :'Senegal', value :'SN' },
    { id:'208', label :'Somalia', value :'SO' },
    { id:'209', label :'Suriname', value :'SR' },
    { id:'210', label :'Sao-Tome-and-Principe', value :'ST' },
    { id:'211', label :'El-Salvador', value :'SV' },
    { id:'212', label :'Syria', value :'212' },
    { id:'213', label :'Swaziland', value :'SZ' },
    { id:'214', label :'Turks-and-Caicos-Islands.', value :'TC' },
    { id:'215', label :'Chad', value :'TD' },
    { id:'216', label :'French-Southern-Territories', value :'TF' },
    { id:'217', label :'Togo', value :'TG' },
    { id:'218', label :'Thailand', value :'TH' },
    { id:'219', label :'Tajikistan', value :'TJ' },
    { id:'220', label :'Tokelau', value :'TK' },
    { id:'222', label :'Turkmenistan', value :'TM' },
    { id:'223', label :'Tunisia', value :'TN' },
    { id:'224', label :'Tonga', value :'TO' },
    { id:'225', label :'Turkey', value :'TR' },
    { id:'226', label :'Trinidad-and-Tobago', value :'TT' },
    { id:'227', label :'Tuvalu', value :'TV' },
    { id:'228', label :'Taiwan', value :'TW' },
    { id:'229', label :'Tanzania', value :'TZ' },
    { id:'230', label :'Ukraine', value :'UA' },
    { id:'231', label :'Uganda', value :'UG' },
    { id:'233', label :'United-States', value :'US' },
    { id:'234', label :'Uruguay', value :'UY' },
    { id:'235', label :'Uzbekistan', value :'UZ' },
    { id:'236', label :'Vatican-City', value :'VA' },
    { id:'237', label :'Saint-Vincent-and-the-Grenadines', value :'VC' },
    { id:'238', label :'Venezuela', value :'VE' },
    { id:'239', label :'British-Virgin-Islands', value :'VG' },
    { id:'240', label :'US-Virgin-Islands', value :'VI' },
    { id:'241', label :'Vietnam', value :'VN' },
    { id:'242', label :'Vanuatu', value :'VU' },
    { id:'243', label :'Wallis-And-Futuna', value :'WF' },
    { id:'244', label :'Samoa', value :'WS' },
    { id:'245', label :'Yemen', value :'YE' },
    { id:'246', label :'Mayotte', value :'YT' },
    { id:'247', label :'South-Africa', value :'ZA' },
    { id:'248', label :'Zambia', value :'ZM' },
    { id:'249', label :'Zimbabwe', value :'ZW' },
    { id:'250', label :'Saint-Martin', value :'250' },
    { id:'251', label :'Pitcairn-Islands', value :'PN' },
    { id:'252', label :'Timor-Leste', value :'TL' },
    { id:'253', label :'Curacao', value :'253' },
    { id:'254', label :'Macao', value :'MO' },
];
